import React from 'react';

import { Box } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';

const ColorCell: React.FC<Pick<GridRenderCellParams<string>, 'value'>> = (
  props
) => {
  return (
    <Box
      sx={{
        width: 15,
        height: 15,
        border: '1px solid #dcdcdc',
        background: props.value
          ? props.value
          : 'linear-gradient(to top left, #fff calc(50% - 1px), #dcdcdc , #fff calc(50% + 1px))'
      }}
    />
  );
};

export default ColorCell;
